import { Invitation } from "@/operator/graphql/types/Invitation";
import validateEmailAddress from "Utils/validateEmailAddress";

export const convertCsvFileToInvitationList = (
  text: string | null | ArrayBuffer
): Invitation[] => {
  const invitationList: Invitation[] = [];
  if (typeof text === "string" || text instanceof String) {
    /**
            \r = CR (Carriage Return): Used as a new line character in Mac OS before X
            \n = LF (Line Feed): Used as a new line character in Unix/Mac OS X
            \r\n = CR + LF: Used as a new line character in Windows

            Therefore, some CSV files may use \r\n instead of \n.
            To circumvent this case, we replace \r\n with \n..
         */
    const standardizedCarriageReturnInCsv = text.replace(/\r?\n/g, "\n");

    const emails = standardizedCarriageReturnInCsv
      .replace(/\n/g, ",")
      .split(",");

    const defaultInvitation: Invitation = {
      email: "",
      isAdmin: false,
    };

    //TECH_DEBT: validate if the emails already exists
    emails.forEach((receivedEmail) => {
      if (validateEmailAddress(receivedEmail)) {
        invitationList.push({
          ...defaultInvitation,
          email: receivedEmail,
        });
      }
    });
  }

  return invitationList;
};
